import { ITankStyle } from "../../common/models/TankStyle";
import restService from "../rest-service/RestService";

const TankStyleDataService = {

    getTankStyles: async (signal?: AbortSignal): Promise<ITankStyle[]> => {

        const path = `tankstyles`;

        const response = await restService.get<ITankStyle[]>(path, signal);
        return response.data;
    },

    saveTankStyles: async (tankStyles: ITankStyle[]): Promise<void> => {

        const path = `tankstyles`;
        await restService.post<ITankStyle[], void>(path, tankStyles);
    },
};



export default TankStyleDataService;

